import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import Editor from "@monaco-editor/react";
import { useSelector, useDispatch } from "react-redux";
import { setSolutions } from "../../features/courses/courseSlice";

const ContinuousCodeEditor = forwardRef(({ lesson }, ref) => {
  const dispatch = useDispatch();
  const editorRef = useRef(null);
  const { solutions } = useSelector((state) => state.courses);


     const [localValue, setLocalValue] = useState("");
    useImperativeHandle(ref, () => ({
      getCurrentContent: () => localValue
    }));
  
      function handleEditorChange(value) {
      setLocalValue(value);

    }
  
    
    useEffect(() => {
      if (lesson) {
        const defaultCode = 
          solutions[lesson._id] || 
          lesson?.progress[0]?.lastSubmission || 
          lesson?.boilerPlateCode || 
          "";
        setLocalValue(defaultCode);
      }
    }, [lesson?._id, solutions]);


  


  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  }

  function handleEditorBeforeMount(monaco) {
    let theme = {
      base: "vs-dark",
      inherit: true,
      rules: [{ token: "type", foreground: "569cd6" }],
      colors: {},
    };
    monaco.editor.defineTheme("my-theme", theme);
  }

  if (!lesson) return null;

  return (
    <Editor
      className="inline-block"
      onChange={handleEditorChange}
      onMount={handleEditorDidMount}
      beforeMount={handleEditorBeforeMount}
      defaultLanguage="apex"
      theme="my-theme"
      value={localValue}
      options={{
        fontSize: "14px",
        minimap: { enabled: false },
        scrollbar: { alwaysConsumeMouseWheel: false },
        scrollBeyondLastLine: false,
      }}
    />
  );
});

export default ContinuousCodeEditor;
